<ul class="breadcrumb">
  <li><a [routerLink]="['/home']"><span class="color-soft-grey-axial">ESTÁS EN </span>Inicio</a></li>
  <li><i class="pi pi-angle-right"></i></li>
  <li><a [routerLink]="['/organizations']">{{view.getEntityBaseName(true)}}</a></li>
  <li><i class="pi pi-angle-right"></i></li>

  <li *ngIf="organizationType!=null"><span> {{organizationType.name}}</span></li>
</ul>
<app-view #view [code]="'organizations.list'" [model]="organizationsFilters" (onEvent)="onEvent($event)"></app-view>
